import styled from 'styled-components';
import { COLOR_WHITE, COLOR_RED, COLOR_BLACK, COLOR_ORANGE } from '../../../assets/styles/colors';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';
import { BodyText } from '../../typography';

export default styled.tr`
  background: ${COLOR_WHITE};
  &:last-child {
    td {
      &:first-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-left-radius: 12px;`)}
      }
      &:last-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-right-radius: 12px;`)}
      }
      &:after {
        display: none;
      }
    }
  }

  td {
    height: 60px;
    text-align: center;
    position: relative;

    a {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    a:hover {
      text-decoration: none;
    }

    .buy-button {
      padding: 4px 20px 3px 20px;
      font-size: 14px;
      text-transform: uppercase;
      min-width: 110px;
      border-radius: 8px;
    }

    .bid-button {
      padding: 4px 20px 3px 20px;
      font-size: 14px;
      text-transform: uppercase;
      margin-left: 8px;
      min-width: 110px;
      border-radius: 8px;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      height: 1px;
      width: 100%;
      background: rgba(47, 46, 65, 0.1);
      left: 0;
    }

    &:first-child {
      a {
        padding-left: 32px;
        text-align: left;
        justify-content: left;
        align-items: center;
      }

      p {
        float: left;
      }

      &:after {
        width: calc(100% - 32px);
        right: 0px;
        left: auto;
      }
    }

    &:nth-child(5) {
      width: 120px;
      /*   width: 180px; */
    }

    &:nth-child(-2) {
      a {
        padding-right: 32px;
        text-align: right;
      }
      width: 280px;
      min-width: 280px;
      /*     width: 180px; */
      &:after {
        width: calc(100% - 32px);
        right: auto;
        left: 0px;
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    display: flex;
    margin-bottom: 16px;
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    border-radius: 12px;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    td {
      width: 100%;
      height: auto;
      padding: 0px 0px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      &:after {
        display: none;
      }

      a {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      &:first-child {
        a {
          padding-top: 24px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
          justify-content: space-between;
        }
      }
      &:nth-child(2) {
        a {
          padding-top: 0px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
        }
      }
      &:nth-child(3) {
        a {
          padding-top: 10px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
        }
      }
      &:nth-child(4) {
        a {
          padding-top: 4px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
        }
      }
      &:nth-child(5) {
        width: 100%;
        a {
          padding-top: 4px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
        }
      }
      &:nth-child(6) {
        a {
          padding-top: 4px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
        }
      }
      &:last-child {
        padding-top: 15px;
        padding-bottom: 24px;
        padding-left: 16px;
        padding-right: 16px;
        button {
          width: 100%;
        }
      }
    }
  }
`;

export const AlertSC = styled.span`
  cursor: pointer;
  position: relative;
  width: 16px;
  height: 16px;
  background: ${COLOR_RED};
  color: ${COLOR_WHITE};
  /* margin-top: 5px; */
  margin-left: 8px;
  font-size: 12px;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-radius: 16px;

  &:before {
    content: '!';
    color: white;
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
  }

  &.black {
    background: ${COLOR_BLACK};
  }

  .tooltip {
    color: ${COLOR_RED};
    font-size: 14px;
    font-weight: 600;
    border-radius: 16px;
    background-color: #ffffff;
    box-shadow: 0 4px 15px 0 rgba(47, 46, 65, 0.15);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    width: 232px;
    position: absolute;
    z-index: 99;
    left: 32px;
    top: -15px;
    svg {
      transform: rotateZ(-90deg);
      position: absolute;
      left: -25px;
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .tooltip {
      width: 200px;
    }
  }
`;

export const TotalValueText = styled.span`
  color: #2f2e41;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  opacity: 0.5;

  &.red {
    color: ${COLOR_RED};
  }
`;

// export const MoreButton = styled.button`
//   display: inline;
//   background: none;
//   border: none;
//   margin: 20px;
// `;

export const DetailText = styled(BodyText)`
  color: ${COLOR_ORANGE};
  text-decoration: underline;
  cursor: pointer;
`;
